import { getCalendarGroupKey } from 'owa-calendar-cache';
import getCalendarPickerStore from './getCalendarPickerStore';
import type CalendarPickerScenarioId from '../store/schema/CalendarPickerScenarioId';

export function doesCalendarGroupHaveExpandedCalendars(
    scenarioId: CalendarPickerScenarioId,
    userIdentity: string,
    calendarGroupId: string
) {
    const store = getCalendarPickerStore(scenarioId);

    return store.expandedCalendarsForCalendarGroup.has(
        getCalendarGroupKey(userIdentity, calendarGroupId)
    );
}
